<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12">
        <h1>利用サービス申請一覧</h1>
      </v-col>
    </v-row>

    <v-row justify="center" v-if="view.errors.length > 0">
      <v-col cols="12">
        <mp-error :errors="view.errors" message-key="message.admin.account.error." />
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12">
        <h2>検索条件</h2>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="3">
        <mp-label>申請サービス</mp-label>
      </v-col>
      <v-col cols="9" outlined tile>
        <mp-input-box min>
          <v-select
            v-model="form.serviceId"
            :items="view.serviceList"
            item-text="text"
            item-value="value"
            label="選択してください"
            id="serviceId"
            hide-details
            solo
            dense
            color="green"
            item-color="green"
          ></v-select>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="3" md="3">
        <mp-label>グループ分類</mp-label>
      </v-col>
      <v-col cols="3" md="3" outlined tile>
        <mp-input-box min>
          <v-select
            v-model="form.groupSmallId"
            :items="view.groupList"
            item-text="text"
            item-value="value"
            label="選択してください"
            id="groupSmallId"
            hide-details
            solo
            dense
            color="green"
            item-color="green"
          ></v-select>
        </mp-input-box>
      </v-col>
      <v-col cols="3" md="3">
        <mp-label>{{ view.keywordLable.ja }}</mp-label>
      </v-col>
      <v-col cols="3" md="3" outlined tile>
        <mp-input-box min>
          <v-text-field
            v-model="form.keyword"
            id="keyword"
            hide-details
            solo
            dense
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="3" md="3">
        <mp-label>氏名</mp-label>
      </v-col>
      <v-col cols="3" md="3" outlined tile>
        <mp-input-box min>
          <v-text-field
            v-model="form.name"
            id="name"
            hide-details
            solo
            dense
          ></v-text-field>
        </mp-input-box>
      </v-col>
      <v-col cols="3" md="3">
        <mp-label>メールアドレス</mp-label>
      </v-col>
      <v-col cols="3" md="3" outlined tile>
        <mp-input-box min>
          <v-text-field
            v-model="form.mailAddress"
            id="mailAddress"
            hide-details
            solo
            dense
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="end">
      <v-col cols="3" md="2" class="py-1">
        <mp-button min wide @click="goSearch">検索</mp-button>
      </v-col>
    </v-row>

    <template v-if="search.show">

      <v-row justify="center">
        <v-col cols="12">
          <h2>検索結果</h2>
        </v-col>
      </v-row>

    </template>

    <template v-if="search.show && search.list.length > 0">

      <v-row justify="center">
        <v-col cols="12" class="py-0">
          <div class="text-right ma-0 py-0 list-count">一覧件数：{{ search.list.length | addComma }}件</div>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12">
          <v-data-table
            v-model="form.selected"
            item-key="accountServiceId"
            :headers="headers"
            :items="search.list"
            locale="ja-jp"
            loading-text="読込中"
            no-data-text="データがありません。"
            hide-default-footer
            mobile-breakpoint=0
            class="elevation-1"
            :page.sync="search.paging.page"
            :items-per-page="search.paging.itemsPerPage"
            @page-count="search.paging.pageCount = $event"
          >
            <template v-slot:[`item.entryDt`]="{ item }">
              {{ item.entryDt | dateFormatter }}
            </template>
            <template v-slot:[`item.serviceName`]="{ item }">
              {{ item.serviceNameJp }}
            </template>
            <template v-slot:[`item.name`]="{ item }">
              <router-link :to="'/admin/account/service/application/detail/' + item.accountId">
                {{ item.name }}
              </router-link>
            </template>
            <template v-slot:[`item.groupName`]="{ item }">
              {{ item.groupLargeNameJp }}＞{{ item.groupSmallNameJp }}
            </template>
            <template v-slot:[`item.companyName`]="{ item }">
              {{ item.companyName }}<v-icon v-if="item.companyId === 0">mdi-new-box</v-icon>
              <br>{{ item.branchName !== null ? item.branchName : '' }}<v-icon v-if="item.branchId === 0">mdi-new-box</v-icon>
            </template>
          </v-data-table>
          <div class="text-center pt-2">
            <v-pagination color="#0F9956" circle v-model="search.paging.page"
                          :length="search.paging.pageCount"></v-pagination>
          </div>
        </v-col>
      </v-row>

    </template>
    <template v-else-if="search.show && search.list.length === 0">

      <v-row justify="center">
        <v-col cols="12" class="pt-0">
          <div>
            検索条件に該当する申請中のアカウントは、ありません。
          </div>
        </v-col>
      </v-row>
    </template>

  </v-container>
</template>

<script>
import MpLabel from '@/components/item/MpLabel.vue'
import MpInputBox from '@/components/item/MpInputBox.vue'
import MpButton from '@/components/item/MpButton.vue'
import { AdminAccountServiceApplication, Common } from '@/api'
import MpError from '@/components/item/MpError'

export default {
  name: 'AdminAccountServiceApplicationList',
  components: {
    MpError,
    MpLabel,
    MpInputBox,
    MpButton
  },
  data: () => ({
    view: {
      errors: [],
      serviceList: [],
      groupList: [],
      keywordLable: {
        ja: ''
      }
    },
    form: {
      serviceId: null,
      groupSmallId: null,
      keyword: '',
      name: '',
      mailAddress: '',
      selected: []
    },
    search: {
      show: false,
      list: [],
      paging: {
        page: 1,
        pageCount: 5,
        itemsPerPage: 50
      }
    },
    headers: []
  }),
  computed: {
    accountList () {
      return this.search.list
    }
  },
  methods: {
    async goSearch () {
      this.form.selected = []
      this.search.list = await AdminAccountServiceApplication.search(this.form)
      await this.$store.dispatch('formAdminAccountServiceApplicationList', this.form)
      // 検索結果表示
      this.search.show = true
    },
    restResult () {
      this.form = this.$store.state.form.adminAccountServiceApplicationList
      this.goSearch()
    },
    async setKeywordLabel () {
      const list = await Common.labelList({ key: 'account.keyword' })
      const ele = list.find(ele => ele.configKey === 'label.account.keyword.ja')
      if (ele === undefined || ele.configVal === undefined) {
        this.view.keywordLable.ja = ''
      } else {
        this.view.keywordLable.ja = ele.configVal
      }
    },
    setHeaders () {
      this.headers = [
        { text: '申請日時', value: 'entryDt', sortable: false, width: 150 },
        { text: '申請サービス', value: 'serviceName', sortable: false, width: 200 },
        { text: 'ID', value: 'mailAddress', sortable: false },
        { text: '氏名', value: 'name', sortable: false, width: 200 },
        { text: '所属', value: 'groupName', sortable: false, width: 220 },
        { text: this.view.keywordLable.ja, value: 'companyName', sortable: false, width: 220 }
      ]
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // 詳細画面からの遷移時は、元の検索結果を表示させる。
      if (from.name === 'AdminAccountServiceApplicationDetail') {
        vm.restResult()
      }
    })
  },
  created: async function () {
    await this.setKeywordLabel()
    this.setHeaders()

    this.view.serviceList = (await Common.userServiceList())
      .map(service => ({
        text: service.serviceName.ja,
        value: service.serviceId
      }))
    this.view.serviceList.unshift({ text: '----', value: '' })

    this.view.groupList = (await Common.groupList())
      .flatMap(groupLarge => groupLarge.groupSmallList
        .map(groupSmall => ({
          text: groupLarge.groupLargeName.ja + '＞' + groupSmall.groupSmallName.ja,
          value: groupSmall.groupSmallId
        }))
      )
    this.view.groupList.unshift({ text: '----', value: '' })
    this.goSearch()
  }
}
</script>

<style scoped>
  .v-data-table td {
    width: 50px;
  }
  .stop {
    background-color: #CCCCCC;
  }
  .v-icon.mdi-new-box {
    color: #E62233;
  }
</style>
